import './_ai-avatar.scss';
import Draggable from 'react-draggable';
import VStore from "../../store";
import {useEffect, useRef, useState} from "react";

const isMobile = window.innerWidth < 768;

export default function AiAvatar() {
    const {currentPage} = VStore();
    const [mouseDownPosition, setMouseDownPosition] = useState({x: 0, y: 0});
    const [isActive, setIsActive] = useState(false);



    const handleMouseDown = (event: any) => {
        const pos = isMobile? event.touches[0] : event;
        setMouseDownPosition({
            x: pos.clientX,
            y: pos.clientY
        });
    };

    const handleMouseUp = (event: any) => {
        const pos = isMobile? event.changedTouches[0] : event;
        if (mouseDownPosition.x === pos.clientX && mouseDownPosition.y === pos.clientY) {
            togglePlayback();
        }
    };

    const videoRef = useRef<HTMLVideoElement>(null);

    function togglePlayback() {
        if (videoRef.current) {
            const video = videoRef.current;
            if (video.paused) {
                video.play();
            } else if (video.ended) {
                video.currentTime = 0;
                video.play();
            } else {
                video.pause();
            }
        }
    };

    useEffect(() => {
        if (currentPage === 'home') {
            setIsActive(true);
            if (videoRef.current) {
                //@ts-ignore
                videoRef.current.play();
            }
        } else {
            setIsActive(false);
            if (videoRef.current) {
                //@ts-ignore
                videoRef.current.pause();
                videoRef.current.currentTime = 0;
            }
        }
    }, [currentPage]);

    return <Draggable>
        <div className={"ai-avatar" + (isActive ? ' active' : '')}>
            <div className=''>
                <video id="video" ref={videoRef}
                       onMouseDown={handleMouseDown}
                       onMouseUp={handleMouseUp}
                       onTouchStart={handleMouseDown}
                       onTouchEnd={handleMouseUp}
                       playsInline
                       controls={false}
                >
                    <source src="./assets/videos/ai-avatar.mp4" type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
                {/*<div className='close-btn' onClick={() => setIsShowAiAvatar(false)}>
                    &#215;
                </div>*/}
            </div>
        </div>
    </Draggable>;
}
